// Generated types for AttributeValue
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { AttributeValueKind } from '../enums';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface AttributeValueReadAPI extends ScopedNodeReadAPI {
  /** Literal value — shape determined by the linked Attribute. NumericAttribute SCALAR=number, RANGE=[min,max], VECTOR=list. DiscreteAttribute BOOLEAN=bool, STRING/ENUM=str. Numeric values are stored in the canonical SI unit (use `unit_override` to record the source unit if different). `None` is permitted as a placeholder for not-yet-set values (templating / declared-without-binding). */
  value?: unknown | null;
  /** How this value was obtained. Informational metadata — does NOT gate slot uniqueness. TARGET=design intent (typical on LogicalParts / Actions / Requirements), MEASURED=empirical reading (typical on PhysicalParts), ESTIMATED=best-guess. A computed value is a DerivedValue, not an AttributeValue. */
  kind?: AttributeValueKind;
  /** Provenance citation — e.g. 'datasheet p.4', 'measured 2026-03-12 by tom', 'derived: sum(children.mass_kg)'. Pairs with `kind` to explain where the value came from. */
  source?: string | null;
  /** Free-form annotations for reviewers. */
  notes?: string | null;
}

export interface AttributeValueWriteAPI extends ScopedNodeWriteAPI {
  /** Literal value — shape determined by the linked Attribute. NumericAttribute SCALAR=number, RANGE=[min,max], VECTOR=list. DiscreteAttribute BOOLEAN=bool, STRING/ENUM=str. Numeric values are stored in the canonical SI unit (use `unit_override` to record the source unit if different). `None` is permitted as a placeholder for not-yet-set values (templating / declared-without-binding). */
  value?: unknown | null;
  /** How this value was obtained. Informational metadata — does NOT gate slot uniqueness. TARGET=design intent (typical on LogicalParts / Actions / Requirements), MEASURED=empirical reading (typical on PhysicalParts), ESTIMATED=best-guess. A computed value is a DerivedValue, not an AttributeValue. */
  kind?: AttributeValueKind;
  /** Provenance citation — e.g. 'datasheet p.4', 'measured 2026-03-12 by tom', 'derived: sum(children.mass_kg)'. Pairs with `kind` to explain where the value came from. */
  source?: string | null;
  /** Free-form annotations for reviewers. */
  notes?: string | null;
  /** The Attribute catalog entry this value is an instance of. */
  attribute?: string;
  /** Optional unit override when the source datasheet uses a non-canonical unit (e.g. inch-lb instead of N·m). Only valid when the linked attribute is a NumericAttribute. */
  unit_override?: string;
  /** The bearer of this AttributeValue (PhysicalPart, LogicalPart, Port, Action, Requirement, Connection, or ItemFlow). */
  owner?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const AttributeValueReadAPISchema: z.ZodType<AttributeValueReadAPI> = ScopedNodeReadAPISchemaObject.extend({
  value: z.unknown().nullable().optional(),
  kind: z.nativeEnum(AttributeValueKind).optional(),
  source: z.string().nullable().optional(),
  notes: z.string().nullable().optional(),
}).passthrough();

export const AttributeValueWriteAPISchema: z.ZodType<AttributeValueWriteAPI> = ScopedNodeWriteAPISchemaObject.extend({
  value: z.unknown().nullable().optional(),
  kind: z.nativeEnum(AttributeValueKind).optional(),
  source: z.string().nullable().optional(),
  notes: z.string().nullable().optional(),
  attribute: z.string().optional(),
  unit_override: z.string().optional(),
  owner: z.string().optional(),
}).passthrough();
